const pollEventStream = async (
    url: string,
    onComplete: (eventData: any) => void,
    onError: (error: any) => void
) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch event stream: ${response.statusText}`);
        }

        const reader = response.body?.getReader();
        const decoder = new TextDecoder();
        let receivedData = "";

        while (true) {
            const result = await reader?.read();
            if (!result || result.done) break;

            receivedData += decoder.decode(result.value, { stream: true });

            const events = receivedData.split("\n");
            for (const event of events) {
                if (event.startsWith("data: ")) {
                    try {
                        const jsonString = event.replace("data: ", "").trim();
                        const eventData = JSON.parse(jsonString);

                        console.log("Received Event Data:", eventData);

                        if (eventData?.status === "COMPLETED" || eventData?.status === "ERROR") {
                            onComplete(eventData);
                            return;
                        }
                    } catch (error) {
                        console.error("Error parsing event data:", error);
                    }
                }
            }
        }
    } catch (err) {
        console.error("Error while polling event stream:", err);
        onError(err);
    }
};

export default pollEventStream;
